module.exports = __webpack_public_path__ + "static/media/allinone_2.1f314aec.svg";